export const selectDashboardData = (state) => state.dashboard;
